class PricingHeaderCellCtrl {
  static bindings = {
    name: '<'
  };

  name;

  constructor() {
    //
  }
}

export const PricingHeaderCellComponent = {
  template: require('./pricingHeaderCell.component.html'),
  controller: PricingHeaderCellCtrl,
  bindings: PricingHeaderCellCtrl.bindings
};
